import Vue from "vue";
import Router from "vue-router";

// 랜딩페이지
import ViewPc from "@/page/PcView";
// import ViewMobile from "@/page/MobileView";

// 솔닥
import PcContainer from "@/page/PcContainer";
// import MobileContainer from "@/page/MobileContainer";

// 파트너스
import PcPartners from "@/page/PcPartners";
// import MobilePartners from "@/page/MobilePartners";

// 바로돌봄 구버전
// import PcBarocare from "@/page/PcBarocare";
// import MobileBarocare from "@/page/MobileBarocare";

// 바로돌봄 New [2024.05.16]
import PcBarocareNew from "@/page/PcBarocareNew";
// import MobileBarocareNew from "@/page/MobileBarocareNew";

// 바로돌봄 B2C [2024.07.08]
import PcbarocareB2c from "@/page/Pcbarocareb2c";
// import MobileBarocareB2c from "@/page/Mobilebarocareb2c";

// 솔닥 컨시어지 메인 [2024.12.13]
import PcbarocareConci from "@/page/PcbarocareConci";
// import MobilebarocareConci from "@/page/MobilebarocareConci";

// 솔닥 컨시어지 서브 [2024.12.13]
import PcBarocareSub1 from "@/page/PcBarocareSub1";
import PcBarocareSub2 from "@/page/PcBarocareSub2";
import PcBarocareSub3 from "@/page/PcBarocareSub3";
import PcBarocareSub4 from "@/page/PcBarocareSub4";
import PcBarocareSub5 from "@/page/PcBarocareSub5";
// import MobileBarocareSub1 from "@/page/MobileBarocareSub1";
// import MobileBarocareSub2 from "@/page/MobileBarocareSub2";
// import MobileBarocareSub3 from "@/page/MobileBarocareSub3";
// import MobileBarocareSub4 from "@/page/MobileBarocareSub4";
// import MobileBarocareSub5 from "@/page/MobileBarocareSub5";

// import PcDiabetes from '@/page/PcDiabetes';
// import MobileDiabetes from "@/page/MobileDiabetes";
Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        { path: "/", name: "Home", component: PcContainer },
        {
            path: "/view",
            name: "view",
            component: ViewPc,
        },
        {
            path: "/partners",
            name: "partners",
            component: PcPartners,
        },
        {
            path: "/barocare",
            name: "barocare",
            component: PcBarocareNew,
        },
        {
            path: "/barocareb2c",
            name: "barocareb2c",
            component: PcbarocareB2c,
        },
        {
            path: "/barocarenew",
            name: "barocarenew",
            component: PcbarocareConci,
            children: [
                {
                    path: "sub1",
                    name: "barocarenew-sub1",
                    component: PcBarocareSub1,
                },
                {
                  path: "sub2",
                  name: "barocarenew-sub2",
                  component: PcBarocareSub2,
                },
                {
                  path: "sub3", 
                  name: "barocarenew-sub3",
                  component: PcBarocareSub3,
                },
                {
                  path: "sub4",
                  name: "barocarenew-sub4",
                  component: PcBarocareSub4,
                },
                {
                  path: "sub5",
                  name: "barocarenew-sub5",
                  component: PcBarocareSub5,
                },
            ],
        },

        // { path: "/", name: "Home", component: MobileContainer },
        // {
        //     path: "/view",
        //     name: "view",
        //     component: ViewMobile,
        // },
        // {
        //     path: "/partners",
        //     name: "partners",
        //     component: MobilePartners,
        // },
        // {
        //     path: "/barocare",
        //     name: "barocare",
        //     component: MobileBarocareNew,
        // },
        // {
        //     path: "/barocareb2c",
        //     name: "barocareb2c",
        //     component: MobileBarocareB2c,
        // },
        // {
        //     path: "/barocarenew",
        //     name: "barocarenew",
        //     component: MobilebarocareConci,
        // },
        // {
        //     path: "/barocarenew",
        //     name: "barocarenew",
        //     component: MobilebarocareConci,
        //     children: [
        //         {
        //             path: "sub1", 
        //             name: "barocarenew-sub2",
        //             component: MobileBarocareSub1,
        //         },
        //         {
        //           path: "sub2", 
        //           name: "barocarenew-sub2",
        //           component: MobileBarocareSub2,
        //         },
        //         {
        //           path: "sub3", 
        //           name: "barocarenew-sub3",
        //           component: MobileBarocareSub3,
        //         },
        //         {
        //           path: "sub4", 
        //           name: "barocarenew-sub4",
        //           component: MobileBarocareSub4,
        //         },
        //         {
        //           path: "sub5", 
        //           name: "barocarenew-sub5",
        //           component: MobileBarocareSub5,
        //         },
        //     ],
        // },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js